import axios from 'axios'
import wrapCall from './wrapCall'

export async function uploadToSasLink(sasURI, data) {
  return await wrapCall(
    axios({
      method: 'Put',
      url: sasURI,
      headers: {
        'x-ms-blob-type': 'BlockBlob'
      },
      validateStatus: status => status === 201,
      data: data
    })
  )
}
